// export class Product {
// 	constructor(idProduct, name, img, description, price, dolarValue, category) {
// 		this.idProduct = idProduct;
// 		this.name = name;
// 		this.img = img;
// 		this.description = description;
// 		this.price = price;
// 		this.dolarValue = dolarValue;
// 		this.category = category;
// 		//Coleccion de compomentes
// 		this.components = [];
// 	}
// 	getTotalComponents = () => {
// 		this.components.reduce((acc, component) => acc + component.quantity, 0);
// 	};
// 	getTotalAmount = () => {
// 		return this.getTotalComponents * this.price * this.dolarValue;
// 	};
// 	getTotalByComponent = (idComponent) => {
// 		return 0;
// 	};
// }

export class Product {
  constructor(
    idProduct,
    sku,
    name,
    img,
    description,
    price,
    volumePrices,
    markedPrice,
    isPromotion,
    dolarValue,
    category,
    categoryName
  ) {
    this.idProduct = idProduct
    this.sku = sku
    this.name = name
    this.img = img
    this.description = description
    this.price = price
    this.volumePrices = volumePrices
    this.markedPrice = markedPrice
    this.isPromotion = isPromotion
    this.dolarValue = dolarValue
    this.category = category
    this.categoryName = categoryName
    //Coleccion de compomentes
    this.components = []
    this.webRelatedProducts = []
  }
  getTotalComponents = () => {
    this.components.reduce((acc, component) => acc + component.quantity, 0)
  }
  getTotalAmount = () => {
    return this.getTotalComponents * this.price * this.dolarValue
  }
  getTotalByComponent = (idComponent) => {
    return 0
  }
}

export class Component {
  constructor(
    idComponent,
    idProduct,
    idColor,
    idSize,
    color,
    colorHexa,
    size,
    stock,
    quantity,
    name,
    images
  ) {
    this.idComponent = idComponent
    this.idProduct = idProduct
    this.idColor = idColor
    this.idSize = idSize
    this.descriptionColor = color
    this.colorHexa = colorHexa
    this.descriptionSize = size
    this.stock = stock
    this.quantity = quantity
    this.name = name
    this.imgComponent = images
  }
}
